import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(email, password); nav("/admin"); }
    catch (e2) {
      const d = e2.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Connexion échouée");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] px-4">
      <form onSubmit={submit} className="w-full max-w-md bg-white p-10 border border-gray-200" data-testid="admin-login-form">
        <img src="/logo.png" alt="DCS Electro" className="h-12 mx-auto mb-6" />
        <h1 className="font-heading text-2xl font-extrabold text-center">Espace administrateur</h1>
        <p className="text-sm text-gray-500 text-center mt-1 mb-8">CRM DCS Electro</p>
        <label className="block text-sm font-medium mb-1">Courriel</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full border border-gray-300 px-4 py-3 mb-4 outline-none focus:border-sapphire" data-testid="admin-email" />
        <label className="block text-sm font-medium mb-1">Mot de passe</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full border border-gray-300 px-4 py-3 mb-4 outline-none focus:border-sapphire" data-testid="admin-password" />
        {err && <p className="text-red-500 text-sm mb-4" data-testid="admin-login-error">{err}</p>}
        <button type="submit" disabled={loading} className="w-full flex items-center justify-center gap-2 bg-sapphire text-white font-semibold py-3.5 hover:bg-[#0a2f52] transition-colors disabled:opacity-60" data-testid="admin-login-btn">
          <Lock size={16} /> {loading ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
